import React, { useEffect, useState } from "react";
import Space from "../ui/Space";
import Label from "../ui/Label";
import Input from "../ui/Input";
import Divider from "../ui/Divider";
import { pubCall } from "../utils/PubSub";
import { showError } from "../ui/Message";
import { KBD } from "../utils/Keybindings";
import { listen } from "../hooks/Listener";

export default function ReconciliationSearch(props) {

    const { controller = "", route = "", signal = {}, selected = false, callback = () => { }, filters = {} } = props;
    const [search, setSearch] = useState("");

    const searchISBN = () => {
        pubCall("reconciliation.search", {isbn : search, work_station_filter : filters?.work_station_filter, limit : 45}, (_s, _r) => {
            if (_s) {
                callback(_r);
            } else {
                showError(_r);
            }
        })
    }

    useEffect(() => {
        const actions = [
            { key: KBD.ESCAPE, action: (e) => { callback(false) } },
            { key: KBD.ENTER, action: (e) => { searchISBN() } },
        ];
        const cleanup = listen(controller, route, actions, false, [KBD.ESCAPE, KBD.ENTER]);
        return cleanup;
    }, [search]);


    return (
        <>
            <div style={{ "width": "310px" }}>
                <div className="shim" /><div className="shim" /><div className="shim" />
                <Space height={25} size={10}>
                    <Label width={130}>Search list for ISBN</Label><Divider vertical />
                    <Input notilde controlled autoselect onChange={(e) => setSearch(e)} placeholder="" autofocus width={150} edit value={search} />
                </Space>
            </div>
        </>)
}